import { useContext } from 'react'
import "./style.scss"
import { AuthContext } from "../../../context/auth";
import { toAbsoluteUrl } from '../../../utils/assetHelper';



const Index = () => {
  const { setUpcomingPurchaseModal } = useContext(AuthContext)

  return (
    <div className="small-modal-wrapper">
      <div className="purchase-modal-content" style={{ padding: '20px' }}>
        <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
          <i className='fas fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '0px', top: '0px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
            setUpcomingPurchaseModal(false)
          }}></i>
          <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#FFF2E5', color: 'var(--white)' }}>
            <img src={toAbsoluteUrl('/media/antibody.png')} style={{ width: '20px', height: '20px' }} alt="" />
          </span>
        </div>
        <div className="purchase-modal-details">
          <h2>Online Purchasing Coming September 2025</h2>
          <p><strong>Call Today and Get it Tomorrow!*</strong></p>
          <a href='tel:9415290647' className='tel-link'>(941) 529-0647</a>
          <p className='small-text'><em>*ordered received after 3:00 PM EST will be processed and shipped on the following day</em></p>
        </div>
      </div>
    </div>
  )
}

export default Index